import FixTx from './FixTx'

export default FixTx
